<template>
  <section>
    <mdb-row class="mt-5">
      <mdb-col md="12">
        <mdb-card cascade>
          <mdb-view class="gradient-card-header elegant-color-dark">
            <h4 class="h4-responsive text-white">
              {{ fieldData.farmName }} - {{ fieldData.name }} Field Detail
            </h4>
          </mdb-view>
          <mdb-card-body>
            <div class="mb-5">
              <router-link :to="{ path: farmLink }">
                <mdb-icon icon="arrow-left" size="lg" />
                Back to Farm
              </router-link>
            </div>
            <farm-field-form
              :farm-id="activeFarmId"
              :field-id="activeFieldId"
              :field-data="fieldData"
              @savedField="getField()"
            />
          </mdb-card-body>
        </mdb-card>
      </mdb-col>
    </mdb-row>
    <Table :headers="fieldServicesHeader" title="Service History">
      <div slot="header">
        <mdb-btn
          color="primary"
          class="float-right"
          @click="fieldServiceFormModal = true"
        >
          Add Field Service
        </mdb-btn>
      </div>
      <tbody slot="rows">
        <tr v-for="(service, index) in fieldData.services" :key="index">
          <td>
            <a @click="openServiceForm(service)">#{{ service.reference }}</a>
          </td>
          <td>{{ service.startDatetime | dateFormat }}</td>
          <td>{{ service.endDatetime | dateFormat }}</td>
          <td>
            <mdb-btn
              color="danger"
              size="sm"
              @click.native="deleteService(service.id)"
            >
              Delete
            </mdb-btn>
          </td>
        </tr>
      </tbody>
    </Table>
    <mdb-row class="mt-5">
      <mdb-col md="12">
        <mdb-card cascade narrow>
          <mdb-btn color="danger" block @click.native="deleteModal = true">
            Delete Field
          </mdb-btn>
        </mdb-card>
      </mdb-col>
    </mdb-row>
    <mdb-modal :show="deleteModal" size="lg" @close="closeAllModals()">
      <mdb-modal-header>
        <mdb-modal-title>Delete Farm?</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        Are you sure you want to delete this field and all of it's data? This
        action can not be reversed.
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn color="danger" @click.native="deleteField()">
          Delete
        </mdb-btn>
        <mdb-btn color="primary" @click.native="closeAllModals()">
          Close
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <mdb-modal
      :show="fieldServiceFormModal"
      size="lg"
      @close="closeAllModals()"
    >
      <mdb-modal-header>
        <mdb-modal-title>
          {{ fieldData.farmName }} - {{ fieldData.name }} Service Form
        </mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <field-service-form
          :farm-id="activeFarmId"
          :field-id="activeFieldId"
          :service-id="activeServiceId"
          @savedService="getField()"
        />
      </mdb-modal-body>
    </mdb-modal>
  </section>
</template>
<script>
import {
  mdbRow,
  mdbCol,
  mdbCard,
  mdbIcon,
  mdbView,
  mdbCardBody,
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter
} from "mdbvue";
import FarmFieldForm from "../components/FarmFieldForm";
import FieldServiceForm from "../components/FieldServiceForm";
import Table from "@/components/Table";
import { fieldsModel } from "../models/field";

export default {
  name: "FarmFieldOverview",
  components: {
    mdbRow,
    mdbCol,
    mdbCard,
    mdbIcon,
    mdbView,
    mdbCardBody,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    FarmFieldForm,
    FieldServiceForm,
    Table
  },
  data() {
    return {
      activeFarmId: "",
      activeFieldId: "",
      activeServiceId: "",
      deleteModal: false,
      fieldData: {},
      fieldServiceFormModal: false,
      fieldServicesHeader: ["Service Id", "Start Date", "End Date", "Delete?"]
    };
  },
  computed: {
    farmLink: function() {
      return `/farms/${this.activeFarmId}`;
    }
  },
  beforeMount() {
    this.activeFarmId = this.$route.params.farmId;
    this.activeFieldId = this.$route.params.fieldId;
    this.getField();
  },
  methods: {
    openServiceForm(service){
      this.activeServiceId = service.id;
      this.activeFieldId = service.fieldId;
      this.fieldServiceFormModal = true;
    },
    closeAllModals() {
      this.deleteModal = false;
      this.fieldServiceFormModal = false;
      this.activeServiceId = "";
    },
    getField() {
      this.closeAllModals();
      fieldsModel
        .get(this.activeFieldId)
        .then(field => (this.fieldData = field));
    },
    deleteField() {
      return fieldsModel
        .remove(this.activeFieldId)
        .then(() => this.$router.push(this.farmLink));
    },
    deleteService(serviceId) {
      return fieldsModel
        .removeService(this.activeFieldId, serviceId)
        .then(() => this.getField());
    }
  }
};
</script>
